/**
 * LA COPIE PENNYLANE, TENUE À JOUR — lot 153, 03/11/2026.
 *
 * Demande de Mohamed : « le poste client doit être vivant et à jour via les
 * règlements Pennylane ». Décision : la copie des factures clients se relit À
 * L'OUVERTURE de la Comptabilité quand sa dernière lecture COMPLÈTE a plus de
 * quinze minutes, et un bouton « Actualiser » la relit à la demande.
 *
 * Ce fichier ne parle à personne : il dit QUAND relire et COMMENT écrire
 * l'heure. La lecture elle-même passe par `lireJusquauBout` (`sources.ts`),
 * la même que le panneau des sources de l'Analyse.
 */

import type { EtatSource } from './sources.js';

/** Quinze minutes : au-delà, la copie est relue à l'ouverture. */
export const FRAICHEUR_MS = 15 * 60 * 1000;

/**
 * LA COPIE DES FACTURES CLIENTS EST-ELLE À JOUR ?
 *
 * Seule une lecture COMPLÈTE compte : une lecture partielle (coupée en route)
 * ou refusée laisse des factures dans leur ancien état, et la croire fraîche
 * afficherait « payée » ou « en retard » à tort. Une date illisible vaut
 * « pas à jour » : mieux vaut relire une fois de trop.
 */
export function copieAJour(etats: readonly EtatSource[], maintenant: Date): boolean {
  const f = etats.find((e) => e.ressource === 'factures_clients');
  const d = f?.derniere;
  if (d === null || d === undefined || d.issue !== 'complete') return false;
  const t = Date.parse(d.lance_le);
  if (Number.isNaN(t)) return false;
  const age = maintenant.getTime() - t;
  return age >= 0 && age < FRAICHEUR_MS;
}

/**
 * L'HEURE DE LA DERNIÈRE LECTURE COMPLÈTE, à Paris, « 09:12 » — précédée de la
 * date quand ce n'est pas aujourd'hui. `null` si la copie n'a jamais été lue
 * en entier.
 */
export function derniereLectureDite(
  etats: readonly EtatSource[],
  maintenant: Date,
): string | null {
  const d = etats.find((e) => e.ressource === 'factures_clients')?.derniere;
  if (d === null || d === undefined || d.issue !== 'complete') return null;
  const t = new Date(d.lance_le);
  if (Number.isNaN(t.getTime())) return null;
  const jour = (x: Date): string =>
    new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'Europe/Paris',
      day: '2-digit',
      month: '2-digit',
    }).format(x);
  const heure = new Intl.DateTimeFormat('fr-FR', {
    timeZone: 'Europe/Paris',
    hour: '2-digit',
    minute: '2-digit',
  }).format(t);
  return jour(t) === jour(maintenant) ? heure : `${jour(t)} à ${heure}`;
}
